/**
 * 1등급 로그인 화면 — 카카오 계정으로 시작
 * (애플/구글 + 기관·관리자 ID/PW 로그인은 앱 심사용으로 넣었다가 출시 후 제거.
 *  원본은 AppLoginPage.social3.bak.js 백업. 기관·관리자 로그인은 /login 페이지에 따로 있음)
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoChatbubble } from 'react-icons/io5';
import { APP_CONFIG } from '../../config/appConfig';
import { useAuth } from '../../context/AuthContext';
import { landingPathFor } from '../../services/userProfileService';

const AppLoginPage = () => {
  const navigate = useNavigate();
  const { currentUser, userData } = useAuth();
  const [busy] = useState(false);

  // 로그인 완료되면 가입유형에 맞는 화면으로
  useEffect(() => {
    if (currentUser && userData) {
      navigate(landingPathFor(userData), { replace: true });
    }
  }, [currentUser, userData, navigate]);

  const handleKakao = () => {
    const restKey = APP_CONFIG.kakaoRestKey;
    if (!restKey || restKey.startsWith('__')) {
      alert('카카오 로그인 준비 중이에요.');
      return;
    }
    const redirectUri = `${window.location.origin}/oauth/kakao`;
    const url = `https://kauth.kakao.com/oauth/authorize?client_id=${restKey}`
      + `&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code`;
    window.location.href = url;
  };

  return (
    <Wrap>
      <Hero>
        <Logo>1등급<Dot>.</Dot></Logo>
        <Tagline>내 아이를 1등급으로</Tagline>
      </Hero>

      <Bottom>
        <KakaoBtn type="button" onClick={handleKakao} disabled={busy}>
          <IoChatbubble size={20} />
          카카오로 시작하기
        </KakaoBtn>
        <Consent>
          시작하기를 누르면{' '}
          <ConsentLink type="button" onClick={() => navigate('/app/terms/parent')}>
            이용약관
          </ConsentLink>
          {' '}및{' '}
          <ConsentLink type="button" onClick={() => navigate('/app/privacy/parent')}>
            개인정보처리방침
          </ConsentLink>
          에 동의하는 것으로 간주됩니다.
        </Consent>
      </Bottom>
    </Wrap>
  );
};

export default AppLoginPage;

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 24px;
`;

const Hero = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const Logo = styled.p`
  font-size: 44px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: -1px;
`;

const Dot = styled.span`
  color: ${({ theme }) => theme.colors.accent.gold};
`;

const Tagline = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
`;

const SocialBtn = styled.button`
  width: 100%;
  max-width: 420px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  &:disabled { opacity: 0.6; }
`;

const KakaoBtn = styled(SocialBtn)`
  background: #FEE500;
  color: #191600;
`;

const Consent = styled.p`
  margin-top: 6px;
  max-width: 420px;
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
  color: #9CA3AF;
`;

const ConsentLink = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
`;
